module.exports = __webpack_public_path__ + "img/Birte-Schmidt-v2-680.a0e67af9.jpg";